import {inject, Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrimusRouteService {
  // Injections
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  get params(): any {
    return this.route.snapshot.queryParamMap['params'];
  }
}
